import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MaintenanceCopy, MaintenanceScenario } from '../../../model/maintenance-banner';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-maintenance-banner',
  standalone: true,
  imports: [CommonModule,MatIconModule],
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.scss'
})
export class MaintenanceBannerComponent {

  scenario = computed<MaintenanceScenario | null>(() => {
    if (environment.isMaintenance) {
      return environment.maintenanceScenario as MaintenanceScenario;
    }
    return null;
  });

  copy = computed(() =>
    this.scenario() ? MaintenanceCopy[this.scenario()!] : null
  );
}

